import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// Initialize Sentry in production if DSN is configured
if (environment.production && environment.sentryDsn) {
  import('@sentry/angular').then(Sentry => {
    Sentry.init({
      dsn: environment.sentryDsn,
      environment: 'production',
      tracesSampleRate: 0.2,
    });
  }).catch(() => {
    // Sentry init failed silently - app continues without monitoring
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
